<template>
  <div>
    <lk-cascader :transfer='true' :disabled='disabled'  :data='list' :load-data='loadData' @on-change='hanleChange' :value="val"></lk-cascader>
  </div>
</template>
<script>
import system from '../services/system';
import utils from '../libs/utils';

export default {
  name: 'location',
  props: {
    val: {
      type: Array,
      // default: [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'val',
    event: 'on-change',
  },
  data() {
    return {
      list: [

      ],
    };
  },
  methods: {
    hanleChange(val) {
      // console.log(val);

      this.$emit('on-change', val);
    },
    getdata(id) {
      this.$store.commit('setDisableLoading', true);
      system.getLocation(id).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          if (id === 1) {
            this.list = [];
          }
          data.forEach((el) => {
            this.list.push({
              value: el.id,
              label: el.name,
              loading: false,
              children: [],
            });
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    loadData(item, cb) {
      item.loading = true;
      this.$store.commit('setDisableLoading', true);
      system.getLocation(item.value).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          // console.log(data);
          //  = data;
          data.forEach((el) => {
            const temp = {
              value: el.id,
              label: el.name,

            };
            if (el.level !== 3) {
              temp.loading = false;
              temp.children = [];
            }
            item.children.push(
              temp,
            );
          });


          item.loading = false;
          cb();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getdata(1);
  },
};

</script>
<style lang="less" scoped>

</style>
